import moment from "moment";

function isValidURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

export function parseCourseStatus(item) {
  const { dtlimite, dtliberacao } = item;
  const hasFullAccess =
    item.situacao?.toUpperCase() === "ACESSO ILIMITADO" ||
    (item.acessoilimitado?.toUpperCase() === "S" &&
      (item.situacao?.toUpperCase() === "CONCLUIDO" ||
        item.situacao?.toUpperCase() === "CONCLUSO"));

  const isFinished =
    item.situacao?.toUpperCase() === "CONCLUIDO" ||
    item.situacao?.toUpperCase() === "CONCLUSO" ||
    item.situacao?.toUpperCase() === "ACESSO ILIMITADO";

  const hasEnrollment = Boolean(item.matriculaid);

  const today = moment();
  const deadline = moment(item.dtlimite, "YYYY-MM-DD[T]HH:mm:ss");
  const isEarly = moment(dtliberacao, "YYYY-MM-DD[T]HH:mm:ss").isAfter(today);
  const isExpired =
    today.isAfter(deadline) || item.situacao?.toUpperCase() === "EXPIRADO";

  const sendCertificate = item.EMITIR_CERTIFICADO === "S";
  const start = moment(dtliberacao, "YYYY-MM-DD[T]HH:mm:ss");
  const end = moment(dtlimite, "YYYY-MM-DD[T]HH:mm:ss");
  const passedTimeInSeconds = today.unix() - start.unix();
  const remainingTimeInSeconds = end.unix() - start.unix();
  const isEnrollmentExternal = isValidURL(item?.link_loja_externa);
  const waitingEnrollmentApproval = item?.AGUARDANDO_LIBERACAO === "S";
  const selfSubscribe = item?.autoinscricao === "A";
  const hasProgress = item?.porcentagem > 0;
  const canBeAccessedNow =
    (hasFullAccess && !isEarly) ||
    (hasEnrollment && !(isEarly || isFinished || isExpired));
  const canEnroll = !hasEnrollment && (selfSubscribe || isEnrollmentExternal);
  const hasAnyEnabledAction =
    canBeAccessedNow || canEnroll || (isFinished && sendCertificate);
  let accessLabel = "";
  if (isFinished) {
    if (hasFullAccess) {
      accessLabel = "Rever";
    } else {
      accessLabel = "Sem acesso";
    }
  } else {
    if (hasProgress) {
      accessLabel = "Continuar";
    } else {
      accessLabel = "Iniciar";
    }
    if (isEarly) {
      accessLabel = "Aguardar Início";
    }
  }
  return {
    elapsedTimePercentage: Math.ceil(
      (passedTimeInSeconds / remainingTimeInSeconds) * 100
    ),
    remainingDays: Math.floor(remainingTimeInSeconds / (60 * 60 * 24)),
    hasFullAccess,
    accessLabel,
    canBeAccessedNow,
    canEnroll,
    hasEnrollment,
    hasProgress,
    hasAnyEnabledAction,
    isFinished,
    isExpired,
    isEarly,
    sendCertificate,
    isEnrollmentExternal,
    waitingEnrollmentApproval,
    selfSubscribe,
  };
}
